class SseRest {

    constructor() {
        this.source = null;
        this.connected = false;
    }

    on(eventType, callback) {
        if (!this.source) {
            this.source = new EventSource("/sse/client");
            this.source.addEventListener("open", () => {
                if (this.connected) {
                    this.source.dispatchEvent(new MessageEvent("RECONNECT_CHANNEL", { data: "\"\"" }));
                }
                this.connected = true;
            });
        }
        this.source.addEventListener(eventType, callback);
        return () => this.source.removeEventListener(eventType, callback);
    }
}

const sseRest = new SseRest();
window.sseRest = sseRest;
export default sseRest;
